export type DeviceType = 'mobile' | 'tablet' | 'desktop' | 'unknown';

export function getDeviceType(): DeviceType {
    if (typeof window === 'undefined') return 'unknown';

    const ua = navigator.userAgent ?? '';
    const width = window.innerWidth ?? 0;

    // iPadOS kan “ligne” Mac i UA, men har ofte touch
    const isIPadLike =
        /iPad/.test(ua) ||
        (navigator.maxTouchPoints >= 1 && /Macintosh/.test(ua));

    // Grov, men praktisk: breakpoint + touch signaler
    if (isIPadLike) return 'tablet';
    if (width > 0 && width < 768) return 'mobile';
    if (width >= 768 && width < 1024) return 'tablet';
    if (width >= 1024) return 'desktop';

    return 'unknown';
}

export type DeviceOS =
    | 'windows'
    | 'mac'
    | 'ios'
    | 'android'
    | 'linux'
    | 'other'
    | 'unknown';

export function getDeviceOS(): DeviceOS {
    if (typeof navigator === 'undefined') return 'unknown';

    // 1. Foretræk User-Agent Client Hints (Chromium)
    const uaData = (navigator as any).userAgentData;
    if (uaData?.platform) {
        const p = uaData.platform.toLowerCase();
        if (p.includes('win')) return 'windows';
        if (p.includes('mac')) return 'mac';
        if (p.includes('ios')) return 'ios';
        if (p.includes('android')) return 'android';
        if (p.includes('linux')) return 'linux';
        return 'other';
    }

    // 2. Fallback: klassisk UA parsing (simpel og grov)
    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes('windows nt')) return 'windows';
    if (ua.includes('mac os') || ua.includes('macintosh')) return 'mac';
    if (ua.includes('iphone') || ua.includes('ipad')) return 'ios';
    if (ua.includes('android')) return 'android';
    if (ua.includes('linux')) return 'linux';

    return 'other';
}

export function getDeviceProps() {
    if (typeof window === 'undefined') return {};

    return {
        DeviceType: getDeviceType(),
        DeviceOS: getDeviceOS()
    } as Record<string, string>;
}
